export default "__VITE_ASSET__D$ybORNM__"